// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"styles_main-layout__2VhAD","content-top":"styles_content-top__SnT6N","discarded":"styles_discarded__3eisx","button":"styles_button__1wqrh"};